// extracted by mini-css-extract-plugin
module.exports = {"badge":"SimpleBadge_badge__QESA-"};